import * as ng from 'angular';
import * as _ from 'lodash-es';
import {ISearchV2Response} from "../../types/SearchTypes";
import {DocMetadata} from "../../types/DocMetadata";
import {IAuthenticatedUserService} from "../../types/ServiceTypes";
import {FolderMetadata} from "../../types/FolderMetadata";
import ResourceIconService from "../../services/ResourceIconService";
import {RootScope} from "../../types/angular-types";
import {IRecentSharedService} from "../services/RecentSharedService";

export interface IScope extends RootScope {
    maxItemsToShow: number;
    documents: DocMetadata[];
    folders: FolderMetadata[];
    loadingError: boolean;
    loadingInProgressFlag: boolean;
    toHumanReadableDate: (date: string) => string;
}

function RecentSharesComponentController($scope: IScope, $log: ng.ILogService, RecentSharedService : IRecentSharedService,
     DateTimeService: any, ResourceIconService: ResourceIconService) {

    // Initialization
    $scope.documents = [];
    $scope.folders = [];
    $scope.maxItemsToShow = 5;

    // Register utility functions for getting icons
    $scope.getFolderIcon = ResourceIconService.getFolderIcon;
    $scope.getFileIcon = ResourceIconService.getFileIcon;

    $scope.loadingError = false;
    $scope.loadingInProgressFlag = true;

    RecentSharedService.getRecentlySharedDocsAndFolders().then(docsAndFolders => {
        $scope.documents = docsAndFolders.documents;
        $scope.folders = docsAndFolders.folders;
    }, function(error) {
        $scope.loadingError = true;
        $log.error('error loading recent viewed files ' + JSON.stringify(error));
    })
    .finally(() => {
        $scope.loadingInProgressFlag = false;
    });

    // Utilities
    $scope.toHumanReadableDate = DateTimeService.getHumanReadableDate;
}
RecentSharesComponentController.$inject = ['$scope', '$log', 'RecentSharedService', 'DateTimeService', 'ResourceIconService'];

angular.module('GorillaBoy.Dboard')
.controller('RecentSharesComponentController', RecentSharesComponentController);
